import { toYYYYMMDD } from "@/features/attorney/views/Entries/entryFilter";
import type { EntryCalendarSummaryDay } from "@/shared/cache";
import { buildCalendarGrid } from "@/v2/lib/weekUtils";
import type { CalendarDaySums } from "./CalendarHourCells";

export function visibleGridDateFilter(month: Date) {
	const { days } = buildCalendarGrid(month.getFullYear(), month.getMonth());
	return {
		from: toYYYYMMDD(days[0]),
		to: toYYYYMMDD(days[days.length - 1]),
	};
}

export function yearDateFilter(month: Date) {
	const year = month.getFullYear();
	return { from: `${year}-01-01`, to: `${year}-12-31` };
}

export function monthDateFilter(month: Date) {
	const year = month.getFullYear();
	const monthIndex = month.getMonth();
	return {
		from: toYYYYMMDD(new Date(year, monthIndex, 1)),
		to: toYYYYMMDD(new Date(year, monthIndex + 1, 0)),
	};
}

export function calendarSummaryToDaySums(
	days: readonly EntryCalendarSummaryDay[],
): Map<string, CalendarDaySums> {
	const map = new Map<string, CalendarDaySums>();
	for (const day of days) {
		map.set(day.date, {
			total: day.total,
			status: new Map(Object.entries(day.byStatus)),
			billable: new Map(Object.entries(day.byBillableCategory)),
		});
	}
	return map;
}
